"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyzeRule = exports.isParsedRuleValue = void 0;
// Add type guards
var isArrayRule = function (item) { return Array.isArray(item); };
var isParsedRuleValue = function (item) {
    return item && typeof item === 'object' && 'type' in item && 'value' in item;
};
exports.isParsedRuleValue = isParsedRuleValue;
var isBetweenRule = function (item) {
    return (item[0] === 'BETWEEN' || item[0] === 'NOT BETWEEN') && item.length === 4;
};
var isExistsRule = function (item) {
    return (item[0] === 'EXISTS' || item[0] === 'NOT EXISTS') && item.length === 2;
};
// Enum instead of object for item types
var RuleItemType;
(function (RuleItemType) {
    RuleItemType[RuleItemType["SINGLE_RULE"] = 1] = "SINGLE_RULE";
    RuleItemType[RuleItemType["NESTED_RULE"] = 2] = "NESTED_RULE";
    RuleItemType[RuleItemType["OPERATOR"] = 3] = "OPERATOR";
    RuleItemType[RuleItemType["SINGLE_RULE_WITH_ARRAY_VALUES"] = 4] = "SINGLE_RULE_WITH_ARRAY_VALUES";
})(RuleItemType || (RuleItemType = {}));
var itemsContainsArr = function (arr) { return arr.some(function (item) { return Array.isArray(item); }); };
// if it contains {unique=true} or {unique=false} then it is using contains with occurences
// when calling in the case ITEM_TYPE.OPERATOR: item can be an object
// For example: LENGTH($body) < 15 AND $body CONTAINS /^\d[\W_]*[A-Za-zА-Яа-я]+/i
var isUsingContainsWithOccurrences = function (item) { return item.search(/{unique=(true|false)}/) !== -1; };
var getItemType = function (item) {
    // an operator   | ParsedRuleValue // example rule true parsedRule: {"type": "boolean","value": true}
    if (typeof item === 'string' || !isArrayRule(item)) {
        return RuleItemType.OPERATOR;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var _a = __read(item, 3), thirdItem = _a[2];
    if (thirdItem && (0, exports.isParsedRuleValue)(thirdItem) && thirdItem.type === 'list' && Array.isArray(thirdItem.value)) {
        return RuleItemType.SINGLE_RULE_WITH_ARRAY_VALUES; // item: [operator, $variable, [values]]. Example: ["CONTAINS", "$text", ["foo, bar"]]
    }
    var typedItem = item;
    if (!itemsContainsArr(typedItem)) {
        return RuleItemType.SINGLE_RULE;
    }
    if (Array.isArray(typedItem[1]))
        return RuleItemType.NESTED_RULE; // item: [operator, [rule1], [rule2]]. Example: [“AND”, [“>”, “$price”, “1”],[“>”, “$price”, “2”]
    return RuleItemType.SINGLE_RULE_WITH_ARRAY_VALUES; // item: [operator, $variable, [values]]. Example: ["CONTAINS", "$text", ["foo, bar"]]
};
var getRule = function (item) {
    var _a = __read(item, 2), operator = _a[0], field = _a[1];
    var firstValue = item[2];
    var secondValue = item[3];
    var value;
    if (item.length === 3) {
        value = firstValue;
    }
    else if (isBetweenRule(item)) {
        var betweenValue = [firstValue, secondValue];
        value = betweenValue;
    }
    else if (isExistsRule(item)) {
        value = {
            type: 'string',
            value: '',
        };
    }
    if (!value) {
        value = {
            type: 'string',
            value: '',
        };
    }
    return {
        sourceData: {
            field: field,
            operator: operator,
            value: value,
        },
    };
};
// Parse the rule and look for containsLENGTH or containsOR isUsingCONTAINSWithOccurrences to disable simple mode
// For nested rule it will be called recursively and accumulate the result in parseResult
// * rules: Get the RuleItem array
// * containsOR: the blang contains "OR" or not
// * hasArrayValues: the blang contains a list of values
// * containsLENGTH: the blang contains "LENGTH" or not
// * isUsingCONTAINSWithOccurrences: the blang editor contains CONTAINS [x,y] or CONTAINS {unique=true} [x,y]
var analyzeRule = function (item, parseResult, isNested) {
    if (parseResult === void 0) { parseResult = {
        rules: [],
        containsOR: false,
        containsLENGTH: false,
        isUsingCONTAINSWithOccurrences: false,
        hasArrayValues: false,
    }; }
    if (isNested === void 0) { isNested = false; }
    var itemType = getItemType(item);
    // console.log('item', item);
    // console.log('itemType', itemType);
    switch (itemType) {
        case RuleItemType.SINGLE_RULE: {
            var typeItem = item;
            if (isArrayRule(typeItem)) {
                var _a = __read(typeItem, 1), operator = _a[0];
                if (operator === 'LENGTH') {
                    parseResult.containsLENGTH = true;
                }
                if (typeof operator === 'string' && isUsingContainsWithOccurrences(operator)) {
                    parseResult.isUsingCONTAINSWithOccurrences = true;
                }
                var data = getRule(typeItem);
                if (data) {
                    parseResult.rules.push(data);
                }
            }
            break;
        }
        case RuleItemType.NESTED_RULE: {
            var typeItem = item;
            typeItem.forEach(function (itemData) { return (0, exports.analyzeRule)(itemData, parseResult, true); });
            break;
        }
        case RuleItemType.OPERATOR:
            if (item === 'OR') {
                parseResult.containsOR = true;
            }
            if (item === 'LENGTH') {
                parseResult.containsLENGTH = true;
            }
            break;
        case RuleItemType.SINGLE_RULE_WITH_ARRAY_VALUES:
            parseResult.hasArrayValues = true;
            break;
        default:
            break;
    }
    // Only return parseResult for the top-level call
    return isNested ? undefined : parseResult;
};
exports.analyzeRule = analyzeRule;
